export default class TimeEntryCommittedEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#time_entry_committed_uuid") ? (elem.querySelector("#time_entry_committed_uuid") as HTMLInputElement).value : null,
            config: elem.querySelector("#time_entry_committed_config") && elem.querySelector("#time_entry_committed_config").value.length > 1 ? JSON.parse(elem.querySelector("#time_entry_committed_config").value) : [],
        }
    }
}